import RESOURCES from '~/resources';
import WhatsappIcon from '~/assets/icons/jsx/whatsappIcon2';
import LinkIcon from '~/assets/icons/jsx/linkIcon';
import MailIcon from '~/assets/icons/jsx/mailIcon';

export const SHARE_CAR_OPTIONS = [
  {
    label: RESOURCES.SHARE_BY_COPY_LINK,
    name: RESOURCES.COPY,
    icon: <LinkIcon />,
    onClickFunc: async () => {
      navigator.clipboard.writeText(window.location.href);
    },
  },
  {
    label: RESOURCES.SHARE_BY_WHATSAPP,
    name: RESOURCES.WHATSAPP,
    icon: <WhatsappIcon />,
    onClickFunc: () => {
      window.open(`https://wa.me/?text=${window.location.href}`);
    },
  },
  {
    label: RESOURCES.SHARE_BY_MAIL,
    name: RESOURCES.EMAIL,
    icon: <MailIcon />,
    onClickFunc: () => {
      window.location.href = `mailto:?subject=I wanted you to see this site&body=Check out this car ${window.location.href}`;
    },
  },
];
